import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { Store } from '@ngrx/store';
import { NavigationService } from './navigation.service';
import { locale as EN } from './navigation/i18n/en';
import { locale as TR } from './navigation/i18n/tr';

import { MatDialog } from '@angular/material/dialog';
import { ParticleState } from '@shared/store/reducers/particle.reduer';
import { ParticleCacheService } from '@core/services/particle-cache.service';
import { GetCommonResourcesAction } from '@shared/store/actions/particle.actions';



@Injectable({
  providedIn: 'root'
})

export class StartupService {
  constructor (private navigationService: NavigationService,
               private particleStore: Store<ParticleState>,
               @Inject(DOCUMENT) private document: any,
               public dialog: MatDialog,
               private particleCacheService: ParticleCacheService,
               ) {
  }

  onStartupAction () {
    this.particleStore.dispatch(new GetCommonResourcesAction());
  }

  getLanguagePacks (): any {
    return [EN, TR];
  }
  showOnboarding() {
    const el = this.document.body.querySelector('#onboarding-welcome-screen');
      if (el && el.style) {el.style.display = 'block'; }
  }

}
